import {  disbursementConstants, nameSpace } from "../constants/disbursement.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null
};

export const winnerDisbursement = (state = initialState, action) => {
  switch (action.type) {
    case disbursementConstants[`WINNER_${nameSpace}_REQUEST`]:
      return {
        ...state,
        loading: true,
        request: action.request
      };
    case disbursementConstants[`WINNER_${nameSpace}_SUCCESS`]:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response,
        error: null
      };
    case disbursementConstants[`WINNER_${nameSpace}_FAILURE`]:
      return {
        ...state,
        loading: false,
        success: false,
        response: null,
        error: action.error
      };
    case disbursementConstants[`WINNER_${nameSpace}_RESET`]:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
